import { actionsTypePolicies } from "./actions"
import { areasTypePolicies } from "./areas"
import { assetsTypePolicies, assetTypesTypePolicies } from "./assets"
import { downloadsTypePolicies } from "./downloads"
import { integrationQueryTypePolicies } from "./integrations"
import { integrationSensorsTypePolicies } from "./sensors/useQueryIntegrationSensors"
import { jobStepTypePolicies, jobsTypePolicies } from "./jobs"
import { notificationPostTypePolicies } from "./notifications"
import { postsTypePolicies, postTypePolicies } from "./posts"
import { processesQueryTypePolicies, processTypePolicies } from "./processes"
import { sensorRuleTypePolicies, sensorTypePolicies, sensorsTypePolicies } from "./sensors"
import { suppliersTypePolicies } from "./suppliers"
import { trainingCourseTypePolicies } from "./training"
import { adminableUsersQueryTypePolicies, userAccreditationTypePolicies } from "./users"
import { reportTrainingUsersQueryTypePolicies } from "./report"
import { loginResultTypePolicies } from "./users/fragments/loginFieldsFragment"
import { foodItemsPolicies } from "./food-items"
import { prepListsTypePolicies } from "./prep"
import { prepListTypePolicies } from "./prep/fragments/prepListFieldsFragment"
import { reportTypePolicies } from "./report/reportTypePolicies"
import { jobStepNoteTypePolicies } from "./jobs/useQueryJobNotes"
import { timersTypePolicies } from "./timers"
import { knowledgesTypePolicies } from "./knowledge"
import { customFieldTypePolicies } from "./customFields"
import { uploadTypePolicies } from "./upload/uploadTypePolicies"
import { timesheetsTypePolicies } from "./timesheets"
import { userTrainingCoursesTypePolicies } from "./training/useQueryUserTrainingCourses"
import { locationsTypePolicies } from "./locations"
import { workflowsTypePolicies } from "./workflow/useQueryWorkflows"
import { myCurrentlyAssignedWorkflowsTypePolicies } from "./workflow/useQueryCurrentlyAssignedWorkflows"
import { printersTypePolicies } from "./printers/useQueryPrinters"

const typePolicies = {
  Query: {
    fields: {
      ...adminableUsersQueryTypePolicies.root,
      ...jobsTypePolicies.root,
      ...loginResultTypePolicies.root,
      ...reportTrainingUsersQueryTypePolicies.root,
      ...prepListTypePolicies.root,
      ...sensorsTypePolicies.root,
      ...sensorTypePolicies.root,
      ...uploadTypePolicies.root
    }
  },
  ...actionsTypePolicies.scoped,
  ...areasTypePolicies.scoped,
  ...assetsTypePolicies.scoped,
  ...assetTypesTypePolicies.scoped,
  ...adminableUsersQueryTypePolicies.scoped,
  ...downloadsTypePolicies.scoped,
  ...foodItemsPolicies.scoped,
  ...processesQueryTypePolicies,
  ...integrationQueryTypePolicies,
  ...integrationSensorsTypePolicies.scoped,
  ...jobsTypePolicies.scoped,
  ...jobStepTypePolicies.scoped,
  ...jobStepNoteTypePolicies.scoped,
  ...locationsTypePolicies.scoped,
  ...loginResultTypePolicies.scoped,
  ...postTypePolicies,
  ...prepListsTypePolicies.scoped,
  ...printersTypePolicies.scoped,
  ...postsTypePolicies.scoped,
  ...processTypePolicies,
  ...notificationPostTypePolicies,
  ...sensorsTypePolicies.scoped,
  ...sensorTypePolicies.scoped,
  ...sensorRuleTypePolicies.scoped,
  ...suppliersTypePolicies.scoped,
  ...trainingCourseTypePolicies,
  ...userAccreditationTypePolicies,
  ...userTrainingCoursesTypePolicies.scoped,
  ...reportTrainingUsersQueryTypePolicies.scoped,
  ...prepListTypePolicies.scoped,
  ...reportTypePolicies.scoped,
  ...timersTypePolicies.scoped,
  ...timesheetsTypePolicies.scoped,
  ...knowledgesTypePolicies.scoped,
  ...customFieldTypePolicies.scoped,
  ...uploadTypePolicies.scoped,
  ...workflowsTypePolicies.scoped,
  ...myCurrentlyAssignedWorkflowsTypePolicies.scoped
}

export { typePolicies }
